var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { CesiumIonAsset } from "./CesiumIonAsset";
import { isTileset } from "../../formats/3d_tiles";
import { Tileset3D } from "../../../objects/tileset_3d";
import { FileLoader } from "../../loaders";
import { ResourceSource } from "../../../objects/tileset_3d/Tileset3D/ResourceSource";
/**
 * A CesiumIonAsset specialization for handling 3DTiles assets
 */
export class CesiumIon3DTilesAsset extends CesiumIonAsset {
    /**
     *
     * @param endpoint
     * @param loader
     */
    static fromEndpoint(endpoint, loader) {
        return __awaiter(this, void 0, void 0, function* () {
            // While apparently the REST docs allow these to be undefined, we require all 3 fields to be present. If they
            // aren't then we return undefined as we can't produce an asset otherwise
            if (typeof endpoint.type === "undefined" ||
                typeof endpoint.url === "undefined" ||
                typeof endpoint.accessToken === "undefined") {
                throw new Error("CesiumIonAssetEndpoint does not have enough data to load an asset from");
            }
            if (endpoint.type !== "3DTILES" /* CesiumIonAssetType.Tiles */)
                throw new Error(`Attempted to create CesiumIon3DTilesAsset from an endpoint of type '${endpoint.type}'`);
            const response = yield FileLoader.loadJson(endpoint.url, {
                headers: {
                    Authorization: `Bearer ${endpoint.accessToken}`,
                },
            });
            if (!isTileset(response)) {
                throw new Error("3DTiles asset endpoint gave us invalid data");
            }
            // Add a metadata field to the tileset to track the URL we got it from, we need this for resolving relative
            // URL paths.
            const tileset = response;
            tileset.extras = {
                source: ResourceSource.fromCesiumEndpoint(endpoint),
            };
            return new CesiumIon3DTilesAsset(tileset, endpoint.url, endpoint.accessToken, endpoint.attributions);
        });
    }
    createTileset3D(styleDesc, pickingManager, requestManager, maximumScreenSpaceError, tileBudget) {
        if (this.tileset !== undefined) {
            // Take ownership of the tileset object away from the endpoint. This prevents creating multiple objects from
            // the same tile tree data structure.
            const tileset = this.tileset;
            this.tileset = undefined;
            return new Tileset3D({
                tileset,
                styleDesc,
                pickingManager,
                requestManager,
                maximumScreenSpaceError,
                tileBudget,
            });
        }
        else {
            throw new Error("Tried to create multiple tileset objects from a single endpoint");
        }
    }
    constructor(tileset, url, token, attributions) {
        super(url, token, attributions);
        // Get the base URL string as all tile paths are relative to it
        const urlBase = new URL(".", url);
        this.urlBase = urlBase.href;
        this.tileset = tileset;
    }
}
